import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Header } from './header.type';
import { BehaviorSubject, catchError, map, Observable, of } from "rxjs";

@Injectable()
export class HeaderService {

  private triageCounter: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor(private httpClient: HttpClient) {
  }

  get(teamId: string): Observable<Header> {
    return this.httpClient.get<Header>(`/api/header/${teamId}`).pipe(
        map(res => {

          if (res.respondMenu?.items) {
            const triageCount = res.respondMenu.items.find(entry => entry.name === 'triage')
            this.setTriageCount(triageCount.counter);
          }

          return Object.assign(new Header(), res)
        }), // create a class instance in order to have access to class functions
        catchError((err: HttpErrorResponse) => {
          if (err.status === 404) {
            return of(null);
          }
        })
    );
  }

  setTriageCount(triageCount: number) {
    if (triageCount){
      this.triageCounter.next(triageCount);
    } else {
      this.triageCounter.next(0);
    }
  }

  getTriageCount(): Observable<number> {
    return this.triageCounter.asObservable();
  }

  decrementTriageCounter() {
    const current = this.triageCounter.value;
    if (current > 0) {
      this.triageCounter.next(this.triageCounter.value - 1)
    } else {
      this.triageCounter.next(0)
    }
  }

  formatPSM(menu: Header): any[] {
    return [
      {
        linkType: 'text',
        name: 'header.quickactions.notificationssettings'
      },
      ...menu.notificationMenu.items,
      {
        linkType: 'separator',
      }, 
      {
        linkType: 'text',
        name: 'header.quickactions.othersettings'
      },  
      ...menu.otherActionsMenu.items,
    ]
  }

  formatAccountMenu(menu: Header): any[] {
    return [
      {
        linkType: 'text',
        name: 'header.account.sign_in',
      },
      {
        linkType: 'separator',
      },
      ...menu.accountMenu.items,
    ]
  }

  getHelpMenu(): any[] {
    return [
      {
        linkType: "text",
        name: 'Help Center'
      },
      {
        linkType: "helplink",
        description: 'Getting Started',
        iconDesc: 'far fa-user-check',
        url: 'https://help.teammood.com/en/collections/342987-getting-started',
        targetBlanck: true
      },
      {
        linkType: "helplink",
        description: 'Best Practices',
        iconDesc: 'far fa-check-circle',
        url: 'https://help.teammood.com/en/collections/343037-best-practices',
        targetBlanck: true
      },
      {
        linkType: "helplink",
        description: 'Keeping your team settings in sync with (reality)',
        iconDesc: 'far fa-bookmark',
        url: 'https://help.teammood.com/en/collections/343085-keeping-your-team-settings-in-sync-with-reality',
        targetBlanck: true
      },
      {
        linkType: "helplink",
        description: 'API And Integrations',
        iconDesc: 'far fa-cogs',
        url: 'https://help.teammood.com/en/collections/342978-api-and-integrations',
        targetBlanck: true
      },
      {
        linkType: "helplink",
        description: 'View all other articles',
        iconDesc: 'far fa-ellipsis-h',
        url: 'https://help.teammood.com/en/',
        targetBlanck: true
      },
      {
        linkType: "separator",
      },
      {
        linkType: "text",
        name: 'What\'s new?',
      },
      {
        linkType: "helplink",
        description: 'Last Updates',
        iconDesc: 'far fa-bullhorn',
        url: 'https://roadmap.teammood.com/teammood/updates',
        targetBlanck: true
      },
      {
        linkType: "helplink",
        description: 'Roadmap',
        iconDesc: 'far fa-map',
        url: 'https://roadmap.teammood.com/teammood/roadmap',
        targetBlanck: true
      }
    ]
  }
}